module.exports = __webpack_public_path__ + "static/img/stationbenefit3.be013b0f.png";